const path = require("path");
import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

let routes = [
  {
    path: "/homePage",
    name: "homePage",
    component: resolve => require(["./../modules/homePage/homePage"], resolve),
    meta: {
      title: "首页"
    }
  },
  {
    path: "/scheduleList",
    name: "scheduleList",
    component: resolve =>
      require(["./../modules/schedule/scheduleList"], resolve),
    meta: {
      title: "招聘行程与流程"
    }
  },
  {
    path: "/newGraduates",
    name: "newGraduates",
    component: resolve =>
      require(["./../modules/schoolRecruit/newGraduates"], resolve),
    meta: {
      title: "应届生招聘",
      keepAlive: true
    }
  },
  {
    path: "/newGraduatesList",
    name: "newGraduatesList",
    component: resolve => require(["./../modules/newGraduatesList"], resolve),
    meta: {
      title: "职位列表",
      keepAlive: true
    }
  },
  {
    path: "/city",
    name: "city",
    component: resolve => require(["./../modules/schoolRecruit/city"], resolve),
    meta: {
      title: "职位列表",
      keepAlive: true
    }
  },
  {
    path: "/positionList",
    name: "positionList",
    component: resolve =>
      require(["./../modules/schoolRecruit/positionList"], resolve),
    meta: {
      title: "应届生招聘",
      keepAlive: true
    }
  },
  {
    path: "/seesionDetail/:id",
    name: "seesionDetail",
    component: resolve =>
      require(["./../modules/schoolRecruit/seesionDetail"], resolve),
    meta: {
      title: "宣讲会详情"
    }
  },
  {
    path: "/sessionApplicants",
    name: "sessionApplicants",
    component: resolve =>
      require(["./../modules/schoolRecruit/sessionApplicants"], resolve),
    meta: {
      title: "宣讲会报名",
      keepAlive: false
    }
  },
  {
    path: "/sessionStatus",
    name: "sessionStatus",
    component: resolve =>
      require(["./../modules/schoolRecruit/sessionStatus"], resolve),
    meta: {
      title: "宣讲会报名",
      keepAlive: true
    }
  },
  {
    path: "/positionDetail/:id",
    name: "positionDetail",
    component: resolve =>
      require(["./../modules/positionDetail/positionDetail"], resolve),
    meta: {
      title: "职位详情"
    }
  },
  {
    path: "/apply",
    name: "apply",
    component: resolve => require(["./../modules/personal/apply"], resolve),
    meta: {
      title: "投递简历"
    }
  },
  {
    path: "/personalCenter",
    name: "personalCenter",
    component: resolve =>
      require(["./../modules/personal/personalCenter"], resolve),
    meta: {
      title: "个人中心"
    }
  },
  {
    path: "/resume",
    name: "resume",
    component: resolve =>
      require(["./../modules/personal/resume-new"], resolve),
    meta: {
      title: "我的简历"
    }
  },
  {
    path: "/baseInfoEdit",
    name: "baseInfoEdit",
    component: resolve =>
      require(["./../modules/personal/edit/baseInfo"], resolve),
    meta: {
      title: "个人信息"
    }
  },
  {
    path: "/deliveryIntentionEdit",
    name: "deliveryIntentionEdit",
    component: resolve =>
      require(["./../modules/personal/edit/deliveryIntention"], resolve),
    meta: {
      title: "投递意向"
    }
  },
  {
    path: "/educationListEdit",
    name: "educationListEdit",
    component: resolve =>
      require(["./../modules/personal/edit/educationList"], resolve),
    meta: {
      title: "教育信息"
    }
  },
  {
    path: "/workListEdit",
    name: "workListEdit",
    component: resolve =>
      require(["./../modules/personal/edit/workList"], resolve),
    meta: {
      title: "实习经历"
    }
  },
  {
    path: "/projectListEdit",
    name: "projectListEdit",
    component: resolve =>
      require(["./../modules/personal/edit/projectList"], resolve),
    meta: {
      title: "项目经验"
    }
  },
  {
    path: "/skillEdit",
    name: "skillEdit",
    component: resolve =>
      require(["./../modules/personal/edit/skill"], resolve),
    meta: {
      title: "技能信息"
    }
  },
  {
    path: "/certificateListEdit",
    name: "certificateListEdit",
    component: resolve =>
      require(["./../modules/personal/edit/certificateList"], resolve),
    meta: {
      title: "其他外语等级"
    }
  },
  {
    path: "/honorEdit",
    name: "honorEdit",
    component: resolve =>
      require(["./../modules/personal/edit/honor.vue"], resolve),
    meta: {
      title: "校园经历"
    }
  },
  {
    path: "/honorRewardList",
    name: "校园经历",
    component: resolve =>
      require(["./../modules/personal/edit/honorRewardList"], resolve),
    meta: {
      title: "校园经历"
    }
  },
  {
    path: "/honorManagerList",
    name: "校园经历",
    component: resolve =>
      require(["./../modules/personal/edit/honorManagerList"], resolve),
    meta: {
      title: "校园经历"
    }
  },
  {
    path: "/honorCompetitionList",
    name: "校园经历",
    component: resolve =>
      require(["./../modules/personal/edit/honorCompetitionList"], resolve),
    meta: {
      title: "校园经历"
    }
  },
  {
    path: "/honorArmyList",
    name: "校园经历",
    component: resolve =>
      require(["./../modules/personal/edit/honorArmyList"], resolve),
    meta: {
      title: "校园经历"
    }
  },
  {
    path: "/selfEvalEdit",
    name: "selfEvalEdit",
    component: resolve =>
      require(["./../modules/personal/edit/selfEval"], resolve),
    meta: {
      title: "自我评价"
    }
  },
  {
    path: "/applyList",
    name: "applyList",
    component: resolve => require(["./../modules/personal/applyList"], resolve),
    meta: {
      title: "投递记录"
    }
  },
  {
    path: "/questionnaire",
    name: "questionnaire",
    component: resolve =>
      require(["./../modules/personal/questionnaire"], resolve),
    meta: {
      title: "调查问卷"
    }
  },
  {
    path: "/talentProject",
    name: "talentProject",
    component: resolve =>
      require(["./../modules/talentProject/talentProject"], resolve),
    meta: {
      title: "人才项目"
    }
  },
  {
    path: "/about",
    name: "about",
    component: resolve => require(["./../modules/about"], resolve),
    meta: {
      title: "关于顺丰"
    }
  },
  {
    path: "/messageList",
    name: "messageList",
    component: resolve =>
      require(["./../modules/message/messageList"], resolve),
    meta: {
      title: "消息动态"
    }
  },
  {
    path: "/messageDetail/:id",
    name: "messageDetail",
    component: resolve =>
      require(["./../modules/message/messageDetail"], resolve),
    meta: {
      title: "文章详情"
    }
  },
  {
    path: "/elegant",
    name: "elegant",
    component: resolve => require(["./../modules/elegant/elegant"], resolve),
    meta: {
      title: "校企丰采"
    }
  },
  {
    path: "/login",
    name: "login",
    component: resolve => require(["./../modules/login/login"], resolve),
    meta: {
      title: "登录"
    }
  },
  {
    path: "/register",
    name: "register",
    component: resolve => require(["./../modules/login/register"], resolve),
    meta: {
      title: "注册"
    }
  },
  {
    path: "/reset",
    name: "重置",
    component: resolve => require(["./../modules/login/reset"], resolve),
    meta: {
      title: "重置"
    }
  },
  {
    path: "/scanSign",
    name: "签到",
    component: resolve => require(["./../modules/scanSign/scanSign"], resolve),
    meta: {
      title: "签到"
    }
  },
  {
    path: "/changeInterViewTime",
    name: "调整面试时间",
    component: resolve =>
      require(["./../modules/personal/changeInterViewTime"], resolve),
    meta: {
      title: "调整面试时间"
    }
  },
  {
    path: "/thirdSelection",
    name: "个人中心",
    component: resolve =>
      require(["./../modules/personal/thirdSelection"], resolve),
    meta: {
      title: "个人中心",
      keepAlive: true
    }
  },
  {
    path: "/thirdResumeUpload",
    name: "第三方简历导入",
    component: resolve =>
      require(["./../modules/personal/thirdResumeUpload"], resolve),
    meta: {
      title: "第三方简历导入"
    }
  },
  // 梦想驿站
  {
    path: "/dreamStateLogin",
    name: "梦想驿站-登录",
    component: resolve =>
      require(["./../modules/login/dreamStateLogin"], resolve),
    meta: {
      title: "登录"
    }
  },
  {
    path: "/dreamStateReset",
    name: "梦想驿站-重置",
    component: resolve =>
      require(["./../modules/login/dreamStateReset"], resolve),
    meta: {
      title: "重置密码"
    }
  },
  {
    path: "/checkOffer",
    name: "checkOffer",
    component: resolve =>
      require(["./../modules/dreamState/checkOffer.vue"], resolve),
    meta: {
      title: "未获取到offer"
    }
  },
  {
    path: "/dreamState",
    name: "梦想驿站",
    component: resolve =>
      require(["./../modules/dreamState/index.vue"], resolve),
    redirect: "/sfNews",
    meta: {
      title: "梦想驿站"
    },
    children: [
      {
        path: "/sfNews",
        name: "顺丰之家",
        component: resolve =>
          require(["./../modules/dreamState/sfNews.vue"], resolve),
        meta: {
          title: "顺丰之家"
        }
      },
      {
        path: "/FAQ",
        name: "问题列表",
        component: resolve =>
          require(["./../modules/dreamState/FAQ.vue"], resolve),
        meta: {
          title: "问题列表"
        }
      },
      {
        path: "/enterGuide",
        name: "入职指南",
        component: resolve =>
          require(["./../modules/dreamState/enterGuide.vue"], resolve),
        meta: {
          title: "入职指南"
        }
      }
    ]
  },
  {
    path: "/detailNews/:id",
    name: "detailNews",
    component: resolve =>
      require(["./../modules/dreamState/newsDetail.vue"], resolve),
    meta: {
      title: "资讯详情页"
    }
  },
  {
    path: "/detailGuide/:id",
    name: "detailGuide",
    component: resolve =>
      require(["./../modules/dreamState/newsDetail.vue"], resolve),
    meta: {
      title: "资讯详情页"
    }
  },
  {
    // 新鹰计划落地页
    path: "/nEIndex",
    name: "newEagleIndex",
    component: resolve => require(["./../modules/newEagle/index.vue"], resolve),
    meta: {
      title: "新鹰计划"
    }
  },
  {
    // 新鹰计划职位列表页
    path: "/nEPostList",
    name: "newEaglePostList",
    component: resolve =>
      require(["./../modules/newEagle/positionList.vue"], resolve),
    meta: {
      title: "新鹰计划",
      keepAlive: true
    }
  },
  {
    // 新鹰计划应聘记录页
    path: "/nEApplyRecordList",
    name: "newEagleApplyRecordList",
    component: resolve =>
      require(["./../modules/newEagle/applyRecordList.vue"], resolve),
    meta: {
      title: "新鹰计划"
    }
  },
  {
    // 新鹰计划简历
    path: "/nEResume",
    name: "newEagleResume",
    component: resolve =>
      require(["./../modules/newEagle/resume.vue"], resolve),
    meta: {
      title: "新鹰计划"
    }
  },
  {
    // FAQ页面
    path: "/homePageFAQ",
    name: "FAQ",
    component: resolve => require(["./../modules/FAQ"], resolve),
    meta: {
      title: "FAQ"
    }
  },
  {
    // 宣讲行程页面
    path: "/preachingTrip",
    name: "preachingTrip",
    component: resolve => require(["./../modules/preachingTrip"], resolve),
    meta: {
      title: "宣讲行程"
    }
  },
  {
    // 宣讲行程页面
    path: "/projectIntroduction",
    name: "projectIntroduction",
    component: resolve =>
      require(["./../modules/projectIntroduction"], resolve),
    meta: {
      title: "项目介绍"
    }
  },
  {
    path: "/schoolAmbassador",
    name: "schoolAmbassador",
    component: resolve =>
      require(["./../modules/schoolAmbassador/index.vue"], resolve),
    redirect: "/schoolAmbassador/ambassadorIntroduction",
    meta: {
      title: "校园大使"
    },
    children: [
      {
        path: "/schoolAmbassador/ambassadorIntroduction",
        name: "ambassadorIntroduction",
        component: resolve =>
          require([
            "./../modules/schoolAmbassador/ambassadorIntroduction.vue"
          ], resolve),
        meta: {
          title: "校园大使"
        }
      },
      {
        path: "/schoolAmbassador/recommendedCode",
        name: "recommendedCode",
        component: resolve =>
          require([
            "./../modules/schoolAmbassador/recommendedCode.vue"
          ], resolve),
        meta: {
          title: "校园大使"
        }
      },
      {
        path: "/schoolAmbassador/myRecommendation",
        name: "myRecommendation",
        component: resolve =>
          require([
            "./../modules/schoolAmbassador/myRecommendation.vue"
          ], resolve),
        meta: {
          title: "校园大使"
        }
      }
    ]
  },
  //   学生端签到
  {
    path: "/lineSignIn",
    name: "lineSignIn",
    component: resolve =>
      require(["./../modules/lineSignIn/index.vue"], resolve),
    meta: {
      title: "签到"
    }
  },
  {
    path: "/lineSignIn/locationPage",
    name: "locationPage",
    component: resolve =>
      require(["./../modules/lineSignIn/components/locationPage.vue"], resolve),
    meta: {
      title: "签到"
    }
  },
  {
    path: "/lineSignIn/failedPage",
    name: "failedPage",
    component: resolve =>
      require(["./../modules/lineSignIn/components/failedPage.vue"], resolve),
    meta: {
      title: "签到"
    }
  },
  {
    path: "/lineSignIn/successPage",
    name: "successPage",
    component: resolve =>
      require(["./../modules/lineSignIn/components/successPage.vue"], resolve),
    meta: {
      title: "签到"
    }
  },
  {
    path: "/lineSignIn/middlePage",
    name: "middlePage",
    component: resolve =>
      require(["./../modules/lineSignIn/components/middlePage.vue"], resolve),
    meta: {
      title: "签到"
    }
  }
];

routes.push(
  {
    path: "/",
    redirect: "/homePage"
  },
  {
    path: "*",
    redirect: "/"
  }
);

export const router = new VueRouter({
  base: path.resolve(__dirname, "../"),
  routes
});

export default {
  routes,
  router
};



// WEBPACK FOOTER //
// ./src/router/routerMap.js